import React, { useContext, createContext, useState, useEffect, useRef } from 'react'

import { useTheme, useMediaQuery } from '@mui/material'
import baseUrl, { pythonUrl } from '../config/baseUrl'
import { useSnackbar } from '../components/SnackbarProvider'

interface SourceState {
  content: string[]
  title: string
  docLink: string
}

interface SidebarContextValue {
  isModelBuilding: boolean
  setIsModelBuilding: React.Dispatch<React.SetStateAction<boolean>>
  updateQuestion: boolean
  setUpdateQuestion: React.Dispatch<React.SetStateAction<boolean>>
  openSpeechToText: boolean
  setOpenSpeechToText: React.Dispatch<React.SetStateAction<boolean>>
  areFilesSelected: boolean
  setAreFilesSelected: React.Dispatch<React.SetStateAction<boolean>>
  showFileUploadBox: boolean
  setShowFileUploadBox: React.Dispatch<React.SetStateAction<boolean>>
  totalPages: number
  setTotalPages: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  sendIsLoading: boolean
  setSendIsLoading: React.Dispatch<React.SetStateAction<boolean>>
  backEndOtp: number
  setBackEndOtp: React.Dispatch<React.SetStateAction<number>>
  isFileUploading: boolean
  setIsFileUploading: React.Dispatch<React.SetStateAction<boolean>>
  tcAccepted: boolean
  setTcAccepted: React.Dispatch<React.SetStateAction<boolean>>
  activeStep: number
  setActiveStep: React.Dispatch<React.SetStateAction<number>>
  upgradeSubscriptionDialog: boolean
  setUpgradeSubscriptionDialog: React.Dispatch<React.SetStateAction<boolean>>
  locationUrl: string
  setLocationUrl: React.Dispatch<React.SetStateAction<string>>
  uniqueString: string
  setUniqueString: React.Dispatch<React.SetStateAction<string>>
  uploadedFileName: string[]
  setUploadedFileName: React.Dispatch<React.SetStateAction<string[]>>
  isRefFileUploaded: boolean
  setIsRefFileUploaded: React.Dispatch<React.SetStateAction<boolean>>
  dataInRightDrawer: string
  setDataInRightDrawer: React.Dispatch<React.SetStateAction<string>>
  openVerifier: boolean
  setOpenVerifier: React.Dispatch<React.SetStateAction<boolean>>
  historyClicked: boolean
  setHistoryClicked: React.Dispatch<React.SetStateAction<boolean>>
  newChatClicked: boolean
  setNewChatClicked: React.Dispatch<React.SetStateAction<boolean>>
  sendBtnClicked: boolean
  setSendBtnClicked: React.Dispatch<React.SetStateAction<boolean>>
  isLoggedIn: boolean
  setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>
  answerToLeftDrawer: string
  setAnswerToLeftDrawer: React.Dispatch<React.SetStateAction<string>>
  isQuestionUpdating: boolean
  setIsQuestionUpdating: React.Dispatch<React.SetStateAction<boolean>>
  sendAnswerToLeftDrawer: string
  setSendAnswerToLeftDrawer: React.Dispatch<React.SetStateAction<string>>

  simplifyText: (text: any) => string
  selectedTab: number
  setSelectedTab: React.Dispatch<React.SetStateAction<number>>

  isLoading: boolean
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
  lastAskedQuestion: string
  setLastAskedQuestion: React.Dispatch<React.SetStateAction<string>>
  lastAnsweredQuestion: string
  setLastAnsweredQuestion: React.Dispatch<React.SetStateAction<string>>
  globalTokenConsumed: any
  setGlobalTokenConsumed: React.Dispatch<React.SetStateAction<any>>
  sidebarOpen: boolean
  setSidebar: React.Dispatch<React.SetStateAction<boolean>>
  aiStorage: any[]
  setAiStorage: React.Dispatch<React.SetStateAction<any[]>>
  inputMessage: string
  setInputMessage: React.Dispatch<React.SetStateAction<string>>
  answer: string
  setAnswer: React.Dispatch<React.SetStateAction<string>>
  source: { content: string[]; title: string; docLink: string }
  setSource: React.Dispatch<
    React.SetStateAction<{ content: string[]; title: string; docLink: string }>
  >
  userStatus: (userId: number) => Promise<any>
  handleSearchCount: (inputQuestion: string, userId: number) => Promise<any>
  deleteUniqueString: (text: string) => Promise<void>
  sendData: (inputQuestion: string) => Promise<void>
  getHistory: (userId: number) => Promise<any>

  message: string // Add message property to the interface
  setMessage: React.Dispatch<React.SetStateAction<string>> // Add setMessage property to the interface
  getUserHistory: (userId: number) => Promise<void>
  userHistory: any[]
  setUserHistory: React.Dispatch<React.SetStateAction<any[]>>
  editHistoryTItleAPi: (title: any, historyId: any) => Promise<void>

  setIsResponseComplete: React.Dispatch<React.SetStateAction<boolean>>
  allHistory: any[]
  setAllHistory: React.Dispatch<React.SetStateAction<any[]>>
  globalThreadId: string | null
  setGlobalThreadId: React.Dispatch<React.SetStateAction<string | null>>
  threadId: any // Update the type to allow null values
  setThreadId: React.Dispatch<React.SetStateAction<any>> // Add setMessage property to the interface
  clearAllHistory: () => Promise<void>

  buttonsDisabled: boolean
  setButtonsDisabled: React.Dispatch<React.SetStateAction<boolean>>

  // Message Context Functionality
  messages: string[]
  activeMessageContext: number
  setActiveMessageContext: React.Dispatch<React.SetStateAction<number>>

  // Search History Functionality

  searchValue: any
  setSearchValue: React.Dispatch<React.SetStateAction<any>>

  // Edit Question
  fetchServerResponse: (question: string) => Promise<boolean>
  editQuestionList: any[]
  setQuestionId: any
  userInput: any
  setUserInput: React.Dispatch<React.SetStateAction<string>> // Corrected property name

  // thredId Deleted

  isThredIdDelete: boolean
  setIsThreadIdDelete: React.Dispatch<React.SetStateAction<boolean>>
  getUserHistorybyThreadId: (tId: string) => Promise<void>
}

const messages = ['']

const SidebarContext = createContext<SidebarContextValue | undefined>(undefined)

interface Props {
  children: React.ReactNode
}
export const SidebarProvider = ({ children }: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  // const hasFetched = useRef(false)
  const [hasFetched, setHasFetched] = useState(false)
  const userId: number = sessionStorage.getItem('userId') as unknown as number
  const token = sessionStorage.getItem('token')
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [answerToLeftDrawer, setAnswerToLeftDrawer] = useState('')
  const [sendBtnClicked, setSendBtnClicked] = useState(false)
  const [newChatClicked, setNewChatClicked] = useState(false)
  const [historyClicked, setHistoryClicked] = useState(false)
  const [openVerifier, setOpenVerifier] = useState(false)
  const [dataInRightDrawer, setDataInRightDrawer] = useState('')
  const [isRefFileUploaded, setIsRefFileUploaded] = useState(false)
  const [uploadedFileName, setUploadedFileName] = useState<string[]>([])
  const [uniqueString, setUniqueString] = useState('')
  const [locationUrl, setLocationUrl] = useState('')
  const [upgradeSubscriptionDialog, setUpgradeSubscriptionDialog] = useState(false)
  const [activeStep, setActiveStep] = useState(0)
  const [tcAccepted, setTcAccepted] = useState(false)
  const [isFileUploading, setIsFileUploading] = useState<boolean>(false)

  const [sendIsLoading, setSendIsLoading] = useState(false)
  const [backEndOtp, setBackEndOtp] = useState(0)

  const [isQuestionUpdating, setIsQuestionUpdating] = useState<boolean>(false)

  const [selectedTab, setSelectedTab] = useState<number>(1)

  const [sidebarOpen, setSidebar] = useState<boolean>(!isMobile)
  const [aiStorage, setAiStorage] = useState<any[]>([])
  const [inputMessage, setInputMessage] = useState('')
  const [answer, setAnswer] = useState('')
  const [message, setMessage] = useState<string>('')

  const [responseData, setResponseData] = useState('')

  const [source, setSource] = useState<SourceState>({
    content: [],
    title: '',
    docLink: '',
  })
  const [tokenConsumed, setTokenConsumed] = useState<string | null>(null)

  const [threadId, setThreadId] = useState<string>('') // Initialize with null
  const [globalThreadId, setGlobalThreadId] = useState<string | null>(null)
  const [userHistory, setUserHistory] = useState<any[]>([])
  const [allHistory, setAllHistory] = useState<any[]>([])

  const [isResponseComplete, setIsResponseComplete] = useState<boolean>(false) // Add this flag

  const [buttonsDisabled, setButtonsDisabled] = useState<boolean>(false)

  const [isThredIdDelete, setIsThreadIdDelete] = useState<boolean>(false)

  // Message Context

  const [activeMessageContext, setActiveMessageContext] = useState<number>(0)

  // Search Histroy
  const [searchValue, setSearchValue] = useState<any>('') // State to store user input

  // for token consumption count

  const [globalTokenConsumed, setGlobalTokenConsumed] = useState<any>(null)
  const [lastAskedQuestion, setLastAskedQuestion] = useState('')
  const [lastAnsweredQuestion, setLastAnsweredQuestion] = useState('')
  // For Pagination

  const [userInput, setUserInput] = useState('')
  const [responseComplete, setResponseComplete] = useState(false)
  const [editQuestion, setEditQuestion] = useState('')
  const [serverResponse, setServerResponse] = useState('')
  const [questionId, setQuestionId] = useState<any>(null)
  const [editQuestionList, setEditQuestionList] = useState<any[]>([])

  // users history page wise on initial load
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [totalPages, setTotalPages] = useState(0)

  const [isModelBuilding, setIsModelBuilding] = useState(false)
  const [updateQuestion, setUpdateQuestion] = useState<boolean>(false)
  const [openSpeechToText, setOpenSpeechToText] = useState(false)
  const [areFilesSelected, setAreFilesSelected] = useState(false)
  const [showFileUploadBox, setShowFileUploadBox] = useState(false)

  // loader
  const [isLoading, setIsLoading] = useState(false)
  const [sendAnswerToLeftDrawer, setSendAnswerToLeftDrawer] = useState('')
  const showSnackbar = useSnackbar()

  useEffect(() => {
    if (userId && !hasFetched) {
      setHasFetched(true)
      getUserHistory(userId)
    }
  }, [userId])

  // useEffect(() => {
  //   if (threadId) {
  //     navigate('/NewChat/' + threadId)
  //   }
  // }, [threadId])

  useEffect(() => {
    // console.log('inside sidebar sendAnswerToLeftDrawer', sendAnswerToLeftDrawer)
  }, [sendAnswerToLeftDrawer])

  useEffect(() => {
    if (threadId !== '' && threadId !== null && threadId !== undefined) {
      getUserHistorybyThreadId(threadId)
    }
  }, [threadId, aiStorage, questionId])

  useEffect(() => {
    if (isThredIdDelete) {
      threadId !== '' &&
        threadId !== null &&
        threadId !== undefined &&
        getUserHistorybyThreadId(threadId)
    }
    setIsResponseComplete(false)
  }, [isThredIdDelete])

  useEffect(() => {
    // if (isResponseComplete) {
    //   postHistory()
    // }
    setIsResponseComplete(false)
  }, [isResponseComplete])

  useEffect(() => {
    if (responseComplete) {
      storeEditedHistory()
    }

    setResponseComplete(false)
  }, [responseComplete])

  useEffect(() => {
    getUserHistory(userId)
  }, [page])

  // useEffect(() => {
  //   if (source?.content.length > 0) {
  //     console.log('source', source)
  //   }
  // }, [source])

  // useEffect(() => {
  //   responseData && console.log('responseData', responseData)
  // }, [responseData])

  const userStatus = async (userId: number) => {
    // setMessage(inputQuestion)
    // alert('inside userStatus')

    try {
      const response = await fetch(`${baseUrl}/api/admin/checkuserstatus/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          authorization: token as string,
        },
        body: JSON.stringify({
          Promptquery: message,
        }),
      })

      const responseData = await response.json()
      // console.log('userStatus responseData :', responseData)
      return responseData
      // responseData?.status && handleSearchCount()
    } catch (error: any) {
      setIsLoading(false)
      // console.log('Error in userStatus API :', error.message)
      showSnackbar(error.message, 'error')

      return error
    }
  }

  const handleSearchCount = async (inputQuestion: string, userId: number) => {
    // alert('inside handleSearchCount')
    try {
      const handleSearchCountResponse = await fetch(`${baseUrl}/api/users/search`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          UserId: userId,
        }),
      })

      const handleSearchCountResponseData = await handleSearchCountResponse.json()

      // console.log('handleSearchCountResponse', handleSearchCountResponse)

      if (!handleSearchCountResponse?.ok) {
        setIsLoading(false)
        showSnackbar(handleSearchCountResponseData?.message, 'error')
        return false
      }

      if (handleSearchCountResponse?.ok) {
        // setIsLoading(false)
        return true
        // console.log('inputQuestion: string, before sendmsg', inputQuestion)
        // inputQuestion && sendData(inputQuestion)
      }
    } catch (error: any) {
      // console.log('Error in searchount api :', error.message)
      showSnackbar(error?.message, 'error')
    }
  }

  const deleteUniqueString = async (text: string) => {
    // console.log('inside deleteUniqueString',text)
    fetch(`${pythonUrl}/pyapi/delete_vectordb/${uniqueString}`, {
      method: 'DELETE',
    })
      .then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json()
          throw new Error(errorData.error || 'An error occurred')
        }
        const data = await response.json()
        const responseData = data.message // Assuming the backend sends a success message
        const responseStatusText = 'File and associated data successfully deleted!'

        setUniqueString('') // Clear the unique string after deletion
        return {
          responseData,
          responseStatusText,
        }
      })
      .catch((error) => {
        return error.message
      })
  }

  const sendData = async (inputQuestion: string) => {
    // alert('inside sendData')
    // let chunks = ''
    let modifiedString = ''
    // console.log('uniqueString', uniqueString)
    // if (inputQuestion) {
    if (isRefFileUploaded && uniqueString) {
      // console.log('inside isRefFileUploaded', isRefFileUploaded, uniqueString)
      // when file is uplaoded
      try {
        setLastAskedQuestion(inputQuestion)
        // const formData = new FormData()

        // formData.append('unique_string', uniqueString)
        // setInputMessage('')
        const response = await fetch(`${pythonUrl}/pyapi/mainqa`, {
          method: 'POST',
          headers: {
            usecase: 'qa',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ question: inputQuestion, uniqueString: uniqueString }),
        })

        if (!response.ok) {
          setIsLoading(false)
          setSendIsLoading(false)
          // const err = await response.json()
          throw new Error('Request failed')
        }

        // console.log('inside isRefFileUploaded ok', response)
        const responseData = await response.json()

        // console.log('inside isRefFileUploaded responseData', responseData)

        if (responseData?.answer) {
          // const reader = response.body.getReader()
          // console.log('responseData', responseData)

          // while (true) {
          //   const { done, value } = await reader.read()
          //   if (done) {
          //     setIsResponseComplete(true)

          //     break
          //   }
          //   chunks += new TextDecoder().decode(value)
          // }

          // const match = chunks.match(/total_tokens_consumed":(\d+)/)
          // const totalTokensConsumed = match ? match[1] : null
          setTokenConsumed(responseData?.total_tokens_consumed)
          // setGlobalTokenConsumed(totalTokensConsumed)
          // console.log('chunks', chunks)
          setResponseData(responseData?.answer)
          setSource(responseData?.source)

          // const data = await response.json()
          // console.log('data doubtful', data)

          modifiedString = simplifyText(responseData?.answer)

          // modifiedString && console.log('modifiedString12', modifiedString)

          modifiedString && setMessage(modifiedString)
          modifiedString && setAnswer(modifiedString)
          modifiedString && setLastAnsweredQuestion(modifiedString)

          postHistory(
            inputQuestion,
            modifiedString,
            userId,
            threadId,
            responseData?.total_tokens_consumed,
            responseData?.source,
            responseData?.summary || null,

            // tokenConsumed:responseData?.total_tokens_consumed,
          )
          modifiedString = ''
        }
        // setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        showSnackbar('An error occurred while submitting the data', 'error')
      }
    } else {
      // when file is not uploaded
      try {
        setLastAskedQuestion(inputQuestion)
        // setInputMessage('')

        const response = await fetch(`${pythonUrl}/pyapi/search`, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ Promptquery: inputQuestion, globalThreadId: globalThreadId }),
        })

        // console.log('response', response)
        if (!response.ok) {
          setIsLoading(false)
          showSnackbar("Server isn't responding", 'error')
          throw new Error('Request failed')
        }

        const responseData = await response.json()

        if (responseData?.result) {
          setTokenConsumed(responseData?.total_tokens_consumed)

          setResponseData(responseData?.result)
          setSource(responseData?.source)

          modifiedString = simplifyText(responseData?.result)
          modifiedString && setMessage(modifiedString)
          modifiedString && setAnswer(modifiedString)
          modifiedString && setLastAnsweredQuestion(modifiedString)

          postHistory(
            inputQuestion,
            modifiedString,
            userId,
            threadId,
            responseData?.total_tokens_consumed,
            responseData?.source,
            responseData?.summary || null,
          )
          modifiedString = ''
          // setIsLoading(false)
        }
      } catch (error) {
        setIsLoading(false)
        setSendIsLoading(false)
        showSnackbar('An error occurred at the server, while submitting the prompt', 'error')
      }
    }
    // }
  }

  const getHistory = async (userId: number) => {
    try {
      const response = await fetch(`${baseUrl}/api/users/FindHistoryAll/${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          authorization: token as string,
        },
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch user history: ${response.statusText}`)
      }

      const { data } = await response.json()
      const last10 = data.slice(0, 6)
      // console.log('getHistory data', last10)
      return last10
    } catch (error) {
      showSnackbar('Error fetching user history', 'error')
    }
  }

  const simplifyText = (text: string) => {
    const mapObj: Record<string, string> = {
      '\\n': '<br />',
      '{"result":"': '',
      '","total_tokens_consumed":2589}': '',
    }

    const initialText = text

    // console.log('initialText', initialText)

    const formattedText = initialText?.replace(
      /{"result":"|","total_tokens_consumed":2589}/gi,
      (matched: string): string => {
        return mapObj[matched] || matched
      },
    )

    // console.log('formattedText', formattedText)

    let modifiedString = ''

    modifiedString = formattedText?.replace('}', '')

    // modifiedString = formattedText?.replace('#', '<h1>')

    modifiedString = modifiedString?.replace('{"result":"', '')

    modifiedString = modifiedString?.replace('<ctx>', '')

    modifiedString = modifiedString?.replace('</ctx>', '')

    // console.log('modifiedString result', modifiedString)
    modifiedString = modifiedString?.replace('","total_tokens_consumed":', '')

    modifiedString = modifiedString?.replace(/\\u201c/g, ' "')

    // console.log('modifiedString /\\u201c/g', modifiedString)

    modifiedString = modifiedString?.replace(/\\u201d/g, '"')

    modifiedString = modifiedString?.replace(/\\u00b7/g, '&middot;')

    // console.log('modifiedString /\\u00b7/g', modifiedString)

    // modifiedString = modifiedString?.replace(/\\"/g, '"')

    // // modifiedString = modifiedString?.replace(/\*\*/, '<b>').replace(/\*\*/, '</b>')

    modifiedString = modifiedString?.replace(/\s*\d+\s*$/, '')

    // modifiedString = modifiedString
    //   ?.replace(/([^.\n])\\n\\n([^.\n])/g, '$1 $2')
    //   ?.replace(/\\n\\n/g, '\n')

    // console.log('modifiedString /s*d+s*$/', modifiedString)

    modifiedString = modifiedString?.replace(/\\n/g, '\n')

    modifiedString = modifiedString?.replace(/\\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')

    modifiedString = modifiedString?.replace(/<br\s*\/?>/gi, '\n')
    // console.log('modifiedString /\\t/g', modifiedString)

    modifiedString = modifiedString.replace(/\((\d+)\)/g, (match, number: string) => {
      if (Number(number) < 50) {
        return `\n(${number})` // Move captured number to the next line
      }
      return match // Keep other matches unchanged
    })

    // modifiedString = modifiedString
    //   ?.replace(/\((\w)\)/g, '\n($1)')
    //   ?.replace(/(?<!\S)(To,)(?!\S)/gi, '\n$1')
    //   ?.replace(/(_{10,})/g, '\n$1')
    //   ?.replace(/(?<!\S)(Sir,)(?!\S)/gi, '\n$1')
    //   ?.replace(/(?<!\S)(^.\d.)(?!\S)/gi, '\n$1')
    //   ?.replace(/(From: .+)/g, '\n$1\n')
    //   ?.replace(/(Date: .+)/g, '\n$1\n')
    //   ?.replace(/\s(\d+\.)/g, '\n$1')
    //   ?.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>')

    // modifiedString = modifiedString
    //   ?.replace(/\*\*(.*?)\*\*|\b\*\*(.*?)\*\*\b/, '<b>$1</b>')
    //   .replace(/([^.])(\\n\\n)/g, '')

    // const pattern = /\b\d+\.\s(?:[^.]*?(?<!\.)\s(?!.*?\.)|[^.\n])*?:/g

    // modifiedString = modifiedString.replace(pattern, '<b>$&</b>')
    // // modifiedString = String.fromCharCode(parseInt(modifiedString.substring(2), 16))

    modifiedString = decodeUnicode(modifiedString)
    // console.log('modifiedString', modifiedString)

    return modifiedString
    // return formattedText
  }

  const decodeUnicode = (str: string) => {
    return str.replace(/\\u[\dA-F]{4}/gi, (match: string) => {
      return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
    })
  }

  const getUserHistorybyThreadId = async (tId: string) => {
    setSource({ content: [], title: '', docLink: '' })
    let modifiedString = ''
    try {
      const userHistoryRespo = await fetch(`${baseUrl}/api/users/gethistory/${tId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          authorization: token as string,
        },
      })

      const userHistoryData = await userHistoryRespo.json()

      // console.log('userHistoryData', userHistoryData)

      setSource(userHistoryData[0]?.source)

      // setAllHistory(userHistoryData?.historydata)

      modifiedString = simplifyText(userHistoryData[0]?.SearchResult)

      userHistoryData[0].SearchResult = modifiedString

      setAllHistory(userHistoryData)
      // setIsLoading(false)
    } catch (error: any) {
      // console.log('This Error occur in fetching history ', error.message)
      showSnackbar(error?.message, 'error')
    }
  }

  // Function 2

  const postHistory = async (
    searchTitle: string,
    searchResult: string,
    userId: number,
    threadId: string,
    tokenConsumed: number,
    source: SourceState,
    summary: string | null,
  ) => {
    // console.log('inside postHistory source', source)

    try {
      const postResponse = await fetch(`${baseUrl}/api/users/StoreHistory1`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          authorization: token as string,

          key: 'Cross-Origin-Opener-Policy',
          value: 'same-origin allow-popups',
        },

        body: JSON.stringify({
          SearchTitle: searchTitle,
          SearchResult: searchResult,
          UserId: userId,
          ThreadId: threadId,
          Token: tokenConsumed,
          source: source,
          summary: summary,
        }),
      })

      const postHistoryData = await postResponse.json()
      // console.log('postHistoryData', postHistoryData)
      if (postHistoryData.status === true) {
        const data = postHistoryData?.data
        setThreadId((prevId) => (prevId = postHistoryData?.data?.ThreadId))
        setGlobalThreadId(postHistoryData?.data?.ThreadId)
        getUserHistory(userId)
        getUserHistorybyThreadId(postHistoryData?.data?.ThreadId)
        // alert('postHistory executed status true')
      }
    } catch (error: any) {
      // console.log(error.message)
      showSnackbar(error?.message, 'error')
      setSendIsLoading(false)
    } finally {
      // setMessage('')
      setAnswer('')
      setIsLoading(false)
      // setLastAskedQuestion('')
      // setSource({ content: [], title: '', docLink: '' })

      // setSummary('')
    }
  }

  const getUserHistory = async (userId: number) => {
    if (userId) {
      try {
        const userHistoryRespo = await fetch(
          `${baseUrl}/api/users/FindHistoryAll/${userId}?page=${page}`,
          {
            method: 'GET',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
              authorization: token as string,
            },
          },
        )
        const userHistoryData = await userHistoryRespo.json()
        if (userHistoryData.status === true) {
          setUserHistory(userHistoryData?.data)
          setTotalPages(userHistoryData?.pagination?.totalPages)
        } else {
          showSnackbar(userHistoryData?.message || 'Failed to fetch history', 'error')
        }
      } catch (error: any) {
        // console.log('This Error occur in fetching history ', error.message)
        showSnackbar(error?.message || 'Failed to fetch history', 'error')
      }
    }
  }

  const editHistoryTItleAPi = async (title: any, historyId: any) => {
    try {
      const response = await fetch(`${baseUrl}/api/users/UpdateSerchTitle/${historyId as string}`, {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          authorization: token as string,
        },
        body: JSON.stringify({
          SearchTitle: title,
        }),
      })

      const editHistoryResponseData = await response.json()

      if (editHistoryResponseData.status === true) {
        getUserHistory(userId)
        showSnackbar(editHistoryResponseData?.message || 'Title edited successfully', 'success')
      } else {
        showSnackbar(editHistoryResponseData?.message || 'Failed to edit title', 'error')
      }
    } catch (error: any) {
      showSnackbar(error?.message || 'Failed to edit title.', 'error')
    }
  }

  const clearAllHistory = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/users/deleteallhistory${userId}`, {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          authorization: token as string,
        },
      })

      const responseData = await response.json()

      if (responseData.status === true) {
        getUserHistory(userId)
        showSnackbar(responseData?.message || 'Chat history deleted successfully', 'success')
      } else {
        showSnackbar(responseData.message || 'Failed to clear chat history.', 'error')
      }
    } catch (error: any) {
      // console.log('Delete chat history error ', error.message)
      showSnackbar(error?.message, 'error')
      getUserHistory(userId)
    } finally {
      getUserHistory(userId)
    }
  }

  // Edit QsetEditQuestionresuestion Scenario

  // Function For Python Server
  const fetchServerResponse = async (question: string) => {
    // setIsLoading(true)
    let modifiedString = ''
    try {
      // console.log('question', question)
      setEditQuestion(question)
      question && setLastAskedQuestion(question)
      const a = question

      if (isRefFileUploaded && uniqueString) {
        // console.log('inside isRefFileUploaded', isRefFileUploaded, uniqueString)
        // when file is uplaoded
        try {
          setLastAskedQuestion(question)
          const formData = new FormData()

          formData.append('uniqueString', uniqueString)
          // setInputMessage('')
          const response = await fetch(`${pythonUrl}/pyapi/mainqa`, {
            method: 'POST',
            headers: {
              usecase: 'qa',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ question: question, uniqueString }),
          })

          if (!response.ok) {
            setIsLoading(false)
            // const err = await response.json()
            throw new Error('Request failed')
          }

          // console.log('inside isRefFileUploaded ok', response)
          const responseData = await response.json()

          // console.log('inside isRefFileUploaded responseData', responseData)

          if (responseData?.answer) {
            setTokenConsumed(responseData?.total_tokens_consumed)
            setResponseData(responseData?.answer)
            setSource(responseData?.source)
            modifiedString = simplifyText(responseData?.answer)
            modifiedString && setMessage(modifiedString)
            modifiedString && setAnswer(modifiedString)
            modifiedString && setServerResponse(modifiedString)
            modifiedString && setLastAnsweredQuestion(modifiedString)
            setEditQuestion('')
            setResponseComplete(true)
            modifiedString = ''
          }
          setIsLoading(false)
          return true
        } catch (error) {
          setIsLoading(false)
          showSnackbar('An error occurred while submitting the data', 'error')
          return false
        }
      } else {
        const response = await fetch(`${pythonUrl}/pyapi/search`, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ Promptquery: a, globalThreadId: globalThreadId }),
        })

        // console.log('response', response)
        if (!response.ok) {
          throw new Error('Request failed')
        }
        // console.log('response from fetchServerResponse', response)

        const responseData = await response.json()
        // console.log('responseData from fetchServerResponse', responseData)

        setIsLoading(false)
        if (responseData?.result) {
          setTokenConsumed(responseData?.total_tokens_consumed)

          setGlobalTokenConsumed(responseData?.total_tokens_consumed)

          setResponseData(responseData?.result)

          setSource(responseData?.source)

          modifiedString = simplifyText(responseData?.result)

          modifiedString && setMessage(modifiedString)
          modifiedString && setAnswer(modifiedString)
          modifiedString && setLastAnsweredQuestion(modifiedString)
          modifiedString && setServerResponse(modifiedString)
          setEditQuestion('')

          // storeEditedHistory()

          // setIsLoading(false)
          setResponseComplete(true)
        }

        // if (response.body) {
        //   const reader = response.body.getReader()
        //   let chunks = ''

        //   while (true) {
        //     const { done, value } = await reader.read()
        //     if (done) {
        //       setResponseComplete(true)
        //       break
        //     }
        //     chunks += new TextDecoder().decode(value)
        //   }

        //   const match = chunks.match(/total_tokens_consumed":(\d+)/)
        //   const totalTokensConsumed = match ? match[1] : null

        //   setTokenConsumed(totalTokensConsumed)
        //   setGlobalTokenConsumed(totalTokensConsumed)
        //   const modifiedString = simplifyText(chunks)
        //   modifiedString && setServerResponse(modifiedString)
        //   // console.log('Last statement in fetchServerResponse',)
        //   setEditQuestion('')

        //   // setIsLoading(false)
        // }

        // const data = await response.json()
        // console.log('going to return true')
        return true
      }
    } catch (error) {
      setIsLoading(false)
      showSnackbar('An error occurred while submitting the form data', 'error')
      return false
    }
  }

  // Function to Store Edit History to Node Server

  const storeEditedHistory = async () => {
    try {
      const storeEditedHistoryResponse = await fetch(`${baseUrl}/api/users/StoreHistory1`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          authorization: token as string,

          key: 'Cross-Origin-Opener-Policy',
          value: 'same-origin allow-popups',
        },
        body: JSON.stringify({
          SearchTitle: lastAskedQuestion,
          SearchResult: serverResponse,
          UserId: userId,
          ParentId: questionId,
          ThreadId: threadId,
          source: source,
          Token: tokenConsumed,
        }),
      })

      const storeEditedHistoryResponseData = await storeEditedHistoryResponse.json()

      if (storeEditedHistoryResponseData.status === true) {
        setLastAskedQuestion('')
        setUserInput('')
        setEditQuestionList(storeEditedHistoryResponseData.data)
        threadId !== '' &&
          threadId !== null &&
          threadId !== undefined &&
          getUserHistorybyThreadId(threadId)
        setIsQuestionUpdating(false)
      }
    } catch (error: any) {
      // console.log('Error in storeEditedHistory Function : ', storeEditedHistory)
      showSnackbar(error?.message, 'error')
      setIsQuestionUpdating(false)
    }
  }

  // To get history by thread Id

  return (
    <>
      <SidebarContext.Provider
        value={{
          isModelBuilding,
          setIsModelBuilding,
          updateQuestion,
          setUpdateQuestion,
          openSpeechToText,
          setOpenSpeechToText,
          areFilesSelected,
          setAreFilesSelected,
          showFileUploadBox,
          setShowFileUploadBox,

          totalPages,
          setTotalPages,
          page,
          setPage,
          sendIsLoading,
          setSendIsLoading,
          backEndOtp,
          setBackEndOtp,
          isFileUploading,
          setIsFileUploading,
          tcAccepted,
          setTcAccepted,
          activeStep,
          setActiveStep,
          upgradeSubscriptionDialog,
          setUpgradeSubscriptionDialog,
          locationUrl,
          setLocationUrl,
          uniqueString,
          setUniqueString,
          uploadedFileName,
          setUploadedFileName,
          isRefFileUploaded,
          setIsRefFileUploaded,
          dataInRightDrawer,
          setDataInRightDrawer,
          openVerifier,
          setOpenVerifier,
          historyClicked,
          setHistoryClicked,
          isLoggedIn,
          setIsLoggedIn,
          answerToLeftDrawer,
          setAnswerToLeftDrawer,
          sendBtnClicked,
          setSendBtnClicked,
          newChatClicked,
          setNewChatClicked,
          isQuestionUpdating,
          setIsQuestionUpdating,
          simplifyText,
          selectedTab,
          setSelectedTab,
          sendAnswerToLeftDrawer,
          setSendAnswerToLeftDrawer,
          isLoading,
          setIsLoading,
          lastAskedQuestion,
          setLastAskedQuestion,
          lastAnsweredQuestion,
          setLastAnsweredQuestion,
          globalTokenConsumed,
          setGlobalTokenConsumed,
          sidebarOpen,
          setSidebar,
          aiStorage,
          setAiStorage,
          inputMessage,
          setInputMessage,
          answer,
          setAnswer,
          source,
          setSource,
          userStatus,
          handleSearchCount,
          deleteUniqueString,
          sendData,
          getHistory,

          message,
          setMessage,
          getUserHistory,
          userHistory,
          setUserHistory,
          editHistoryTItleAPi,
          allHistory,
          setAllHistory,
          setIsResponseComplete,
          threadId,
          setThreadId,
          globalThreadId,
          setGlobalThreadId,
          clearAllHistory,

          buttonsDisabled,
          setButtonsDisabled,

          // Message Context

          messages,
          activeMessageContext,
          setActiveMessageContext,
          searchValue,
          setSearchValue,

          // Edit Question Functionality
          fetchServerResponse,
          editQuestionList,
          setQuestionId,
          userInput,
          setUserInput,

          // token consumption

          // thredId Deleted
          isThredIdDelete,
          setIsThreadIdDelete,
          getUserHistorybyThreadId,
        }}
      >
        {children}
      </SidebarContext.Provider>
    </>
  )
}

export const useSidebarContext = () => {
  const sidebarContext = useContext(SidebarContext)
  if (sidebarContext === undefined) {
    throw new Error('useSidebarContext must be inside a SidebarProvider')
  }
  return sidebarContext
}

export default SidebarContext
